import request from '@/util/request'
import localCache from '../util/localCache';

export function addRecordEditLog(params) {
    params.token = localCache.getToken()
    return request({
        url: '/recordEditLog',
        method: 'post',
        params
    })
}
export function addRecordBatchEditLog(params) {
    params.token = localCache.getToken()
    return request({
        url: '/addRecordBatchEditLog',
        method: 'post',
        params
    })
}
export function addRecordStaffEditLog(params) {
    params.token = localCache.getToken()
    return request({
        url: '/addRecordStaffEditLog',
        method: 'post',
        params
    })
}
export function getRecordEditLogList(params={}) {
    params.token = localCache.getToken()
    return request({
        url: '/getRecordEditLogList',
        method: 'get',
        params
    })
}
export function getRecordEditLogPageList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getRecordEditLogPageList',
        method: 'get',
        params
    })
}
export function editSupplierRecord(params) {
    params.token = localCache.getToken()
    return request({
        url: '/editSupplierRecord',
        method: 'post',
        params
    })
}
export function editRecord(params) {
    params.token = localCache.getToken()
    return request({
        url: '/editRecord',
        method: 'post',
        params
    })
}
